import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./assets/css/common.css";
import "./utils/function";
import ScrollToTop from './utils/ScrollTop';
import Home from "./pages/Home";
import Board from "./pages/Board";
import BoardDetail from "./pages/BoardDetail";
import Directions from "./pages/Directions";
import SitePrivacy from "./pages/SitePrivacy";
import EmailRefuse from "./pages/EmailRefuse";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Board" element={<Board />} />
        <Route path="/BoardDetail" element={<BoardDetail />} />
        <Route path="/Directions" element={<Directions />} />
        <Route path="/SitePrivacy" element={<SitePrivacy />}/>
        <Route path="/EmailRefuse" element={<EmailRefuse />}/>
      </Routes>
      <Footer />
    </Router>
  )
}

export default App; 
 